<template>
  <div class="link-header clearfix">
    <!-- logo 这里需要传值customizeLozgo和isCustomizeLogo-->
    <div class="header-left">
      <slot name="sign">
        <bsLinkLogo
          v-if="isLogo"
          :logo-info="logoInfo"
          :is-thirdparty="isThirdparty"
        />
        <div
          v-else
          class="title-wrapper"
        >
          <svg class="title-img">
            <use :xlink:href="headerData.fileType" />
          </svg><co-tips
            :content="headerData.title"
            placement="bottom"
          >
            <div class="title-name">
              {{ headerData.title }}
            </div>
          </co-tips><span
            v-show="headerData.isVirus"
            class="virus"
          >{{ $t('病毒') }}</span>
        </div>
      </slot>
      <!-- 预热升级的图标 -->
      <!--<span-->
      <!--v-if="isShowUfo"-->
      <!--class="fl-r po-r pre-logo cp"-->
      <!--&gt;-->
      <!--<img-->
      <!--class="ufo-icon"-->
      <!--src="../../../../static/image/ufo.svg"-->
      <!--&gt;-->
      <!--<div class="tritop">-->
      <!--{{ $t('全新品牌升级敬请期待') }}-->
      <!--</div>-->
      <!--</span>-->
    </div>
    <div class="header-right clearfix">
      <!-- language change -->
      <div class="left link-lang">
        <bs-lang />
      </div>
      <template v-if="isShowLogin">
        <div
          v-if="!userInfo.user_id"
          class="login pointer left"
          @click="logIn"
        >
          {{ $t('登录') }}
        </div>
        <co-menu
          v-else
          ref="headMenu"
          class="head-wrapper left"
          btn-class="head pointer"
          menu-width="150"
        >
          <template slot="btname">
            <span
              class="head pointer"
              :style="{background: userInfo.color}"
            >{{ firstLetter }}</span>
          </template>
          <template slot="drop-down-slot-ul">
            <ul class="head-ul">
              <li class="head-li">
                <co-tips
                  :content="userInfo.user_name"
                  position="bottom"
                >
                  <span>{{ userInfo.user_name }}</span>
                </co-tips>
              </li>
              <li
                v-for="val in loginList"
                :key="val.key"
                class="head-li"
                @click="clickMenuItem"
              >
                <span>{{ val.name }}</span>
              </li>
            </ul>
          </template>
        </co-menu>
      </template>
    </div>
    <slot name="default" />
  </div>
</template>
<script>
import bsLinkLogo from 'components/business/link/linkLogo/index.vue'
import coMenu from 'components/common/menu/index.vue'
import { resolvePath, typeIcon, gotoLogin } from 'js/util/util'
import bsLang from 'components/business/lang/index.vue'
import coTips from 'components/common/tips/index.vue'
import _$ from 'js/api/getdata'
import Cookie from 'js/lib/cookie'

export default {
  components: {
    bsLinkLogo,
    coMenu,
    bsLang,
    coTips,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isShowLogin: {
      type: Boolean,
      default: true,
    },
    isLogo: {
      type: Boolean,
      default: true,
    },
    isThirdparty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loginList: [
        {
          name: this.$t('注销'),
          key: 2,
        },
      ],
      THIRD_LOGOUT_URL: '', // 三方url
      THIRD_LOGIN_USER: undefined, // 三方认证cookie
    }
  },
  computed: {
    /**
             * 首字母
             */
    firstLetter() {
      if (this.userInfo && this.userInfo.user_name) {
        return this.userInfo.user_name.substr(0, 1).toLocaleUpperCase()
      }
      return ''
    },
    headerData() {
      return {
        title: resolvePath(this.data.path).name || '',
        fileType: `#${typeIcon(resolvePath(this.data.path).type)}`,
        isVirus: this.data.isvirus,
      }
    },
    /**
             * 用户信息
             */
    userInfo() {
      return this.$store.state.lenovoData.userInfo
    },
    /**
             * logo的信息  之后有了数据加上
             */

    /**
             * logo的数据
             */
    logoInfo() {
      if (this.data && this.data.ext) {
        return {
          logo: `data:image/jpeg;base64,${this.data.ext.logo}` || '',
          title: this.data.ext.title || '联想企业网盘',
        }
      }
      return { logo: '', title: '联想企业网盘' }
    },
  },
  methods: {
    /**
             *登录
             */
    logIn() {
      gotoLogin()
    },

    // 登出路径
    thirdLogOutUrl(LENOVO_SESS_ID) {
      Cookie.set('X-LENOVO-SESS-ID', '', { path: '/', expires: -1 })
      // 清除三方cookie  localStorage
      Cookie.set('LOGIN-USER-SOURCE', '', {
        path: '/',
        expires: -1,
      })
      localStorage.setItem('thirdLogOutUrl', '')
      if (this.THIRD_LOGIN_USER) {
        const isOriDomain = this.THIRD_LOGOUT_URL.includes('oriDomain')
        if (isOriDomain) {
          const logoutUrl = this.THIRD_LOGOUT_URL.split('?')[0]
          const oriDomain = this.THIRD_LOGOUT_URL.split('?')[1]
          window.location.href = `${logoutUrl}/${this.THIRD_LOGIN_USER}?terminal=web&lenovosess=${LENOVO_SESS_ID}&${oriDomain}`
        } else {
          window.location.href = `${this.THIRD_LOGOUT_URL}/${this.THIRD_LOGIN_USER}?terminal=web&lenovosess=${LENOVO_SESS_ID}`
        }
      } else {
        window.location.reload()
      }
    },

    /**
             * 注销
             */
    logOut() {
      // 网盘的sessionid
      const LENOVO_SESS_ID = Cookie.get('X-LENOVO-SESS-ID')
      // 三方认证cookie
      this.THIRD_LOGIN_USER = Cookie.get('LOGIN-USER-SOURCE')
      // 第三方默认跳转登出路径
      if (this.THIRD_LOGIN_USER) {
        this.THIRD_LOGOUT_URL = localStorage.getItem('thirdLogOutUrl')
      }
      window.$bsWebTool.getTaskInfo((res) => {
        if (res && res.info && res.info.is_exist_transfer_task) {
          window.$confirm.show({
            value: true,
            isShow: true,
            onlyOne: false,
            title: '提示',
            sureBtn: '确定',
            cancelBtn: '取消',
            content: '存在未完成的传输任务，退出登录后会暂停，是否继续',
            sure: () => {
              window.$bsWebTool.pause(() => {
                window.$bsWebTool.loginOut()
                _$.postData('logout')
                  .then(() => {
                    this.thirdLogOutUrl(LENOVO_SESS_ID)
                  })
              })
            },
            cancel() {
              window.$confirm.hide()
            },
          })
        } else {
          _$.postData('logout')
            .then(() => {
              this.thirdLogOutUrl(LENOVO_SESS_ID)
            })
        }
      })
    },
    /**
             * 登录操作
             */
    clickMenuItem() {
      const me = this
      window.$confirm.show({
        value: true,
        isShow: true,
        onlyOne: true,
        title: '提示',
        sureBtn: '确定',
        content: this.$t('是否注销当前账号？'),
        sure() {
          window.$confirm.hide()
          me.logOut()
        },
      })
      this.$refs.headMenu.isShowMenu = false
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
.header-left{
  float: left;
  height: 50px;
  line-height: 50px;
}
.title-wrapper{
  display: inline-block;
  height: 50px;
  line-height: 50px;
  .title-img{
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    .img{
      width: 20px;
      height: 20px;
    }
  }
  .title-name{
    margin-left: 12px;
    font-size: 14px;
    color: #282E3D;
    letter-spacing: 0;
    max-width: 580px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    display: inline-block;
    height: 20px;
    vertical-align: middle;
  }
  .virus {
    font-size: 12px;
    color: #FF5554;
    border: 1px solid #FF5554;
    border-radius: 2px;
    padding: 0 2px;
    margin-left: 8px;
    vertical-align: middle;
  }
}

//功能按钮
.header-right{
  float: right;
  height: 50px;
  padding: 8px 0px;
  box-sizing: border-box;
  .link-lang{
    height: 32px;
    line-height: 32px;
    margin-right: 20px;
  }
}
//右侧栏控制
.control-right{
  width: 33px;
  padding-left: 4px;
  text-align: center;
  padding-top: 3px;
  .right-column{
    width: 24px;
    height: 24px;
  }
}
.l-lang{
  float: left;
  width: 93px;
  margin-left: 12px;
}
//登录
.login{
  float: left;
  height: 32px;
  line-height: 32px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1B2733;
  cursor: pointer;
}
.login:hover{
  text-decoration: underline;
}
// 头像部分
.head-wrapper{
  float: left;
  .head-ul:first-child:after{
    display: block;
    content: "";
    width: 118px;
    border-bottom: 1px solid #E8EBEF;
    position: absolute;
    top: 52px;
    left: 16px;
  }
  .head-li{
    width: 150px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #1B2733;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .head-li:first-of-type{
    margin-bottom: 17px;
  }
  li:hover{
    background-color: #f7f6f3;
  }
}
// 弹框
.dialog-content{
  margin-left: 24px;
  height: 48px;
  box-sizing: border-box;
  line-height: 48px;
  .dialog-svg{
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    vertical-align: -7px;
  }
  span{
    display: inline-block;
    height: 48px;
    line-height: 48px;
  }
}
.link-header{
  width: 100%;
  height: 50px;
  position: relative;
}
// 下拉三角的图标
.ufo-icon {
  vertical-align: middle;
  margin-left: 15px;
}
.pre-logo:hover .tritop {
  display: block;
}
.tritop {
  height: 42px;
  background: #FF753C;
  position: relative;
  color: #FFF;
  font-size: 14px;
  padding: 0px 12px;
  line-height: 42px;
  box-shadow: 0 2px 8px 0;
  border-radius: 2px;
  display: none;
  left: -10px;
  top: 6px;
}
.tritop:before{
  content: "";
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #FF753C;
  position: absolute;
  top: -10px;
  left: 30px;
}

</style>
